/**
 * Classificação de falha de carregamento de chunk.
 *
 * Não conhece a origem da captura: a mesma regra vale para qualquer costura, e manter a
 * função cega à origem é o que garante essa independência por construção.
 */

const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';

/**
 * Duas expressões, e não uma: a variante de CSS insere "css" entre "loading" e "chunk",
 * então um único padrão com "loading chunk" adjacente não a alcançaria.
 */
const CHUNK_LOAD_MESSAGE_PATTERNS: readonly RegExp[] = [
  /loading chunk .* failed/i,
  /loading css chunk .* failed/i,
];

/** Recebe a mensagem já sanitizada; nenhum padrão aqui depende de texto cru. */
export function isChunkLoadError(name: string, message: string): boolean {
  if (name === CHUNK_LOAD_ERROR_NAME) {
    return true;
  }

  return CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}
